import React from "react";
import { Link } from "react-router-dom";
import { Car, Users, ShieldCheck, Phone, ArrowRight, Check, Moon } from "lucide-react";
import { safeRide, contact } from "../mock";

const iconMap = { Car, Users, ShieldCheck };

const SafeRide = () => {
  return (
    <div>
      {/* HERO */}
      <section className="relative pt-36 pb-24 overflow-hidden">
        <div className="absolute inset-0">
          <img src={safeRide.heroImage} alt="Miami nightlife" className="h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0c1620]/90 via-[#0c1620]/80 to-[#0c1620]" />
        </div>
        <div className="relative z-10 max-w-4xl mx-auto px-5 text-center">
          <p className="reveal inline-flex items-center gap-2 font-display text-xs uppercase tracking-[0.4em] text-[var(--gold)] mb-4">
            <Moon size={14} /> Nightlife • Events • Peace of Mind
          </p>
          <h1 className="reveal font-display text-4xl sm:text-6xl font-extrabold text-white leading-tight">
            Shadow Path SafeRide
          </h1>
          <p className="reveal mt-3 font-display text-xl text-gold-gradient font-semibold">Luxury Pickup &amp; Car Return Service</p>
          <p className="reveal mt-6 text-lg text-gray-200 max-w-2xl mx-auto leading-relaxed">
            Enjoy your night worry-free. Our chauffeurs pick you up in a luxury Escalade while a second driver returns your car safely to your location.
          </p>
          <Link to="/book" className="reveal btn-gold mt-8 inline-flex items-center gap-2 rounded-full px-8 py-4 text-sm font-semibold uppercase tracking-widest">
            Book SafeRide Now <ArrowRight size={16} />
          </Link>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="py-20">
        <div className="max-w-6xl mx-auto px-5 lg:px-8">
          <div className="reveal text-center mb-14">
            <p className="font-display text-xs uppercase tracking-[0.4em] text-[var(--gold)] mb-3">Simple &amp; Seamless</p>
            <h2 className="font-display text-3xl sm:text-5xl font-extrabold text-white">How Shadow Path SafeRide Works</h2>
          </div>
          <div className="grid gap-7 md:grid-cols-3">
            {safeRide.steps.map((step, i) => {
              const Icon = iconMap[step.icon];
              return (
                <div key={i} className="reveal lux-card relative rounded-2xl border border-white/10 bg-[#13212e] p-8 text-center">
                  <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-[var(--gold)]/10 border border-[var(--gold)]/30 text-[var(--gold)]">
                    <Icon size={28} />
                  </div>
                  <div className="mt-4 font-display text-5xl font-extrabold text-white/10">0{i + 1}</div>
                  <p className="mt-2 text-gray-200 leading-relaxed">{step.text}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* BENEFITS */}
      <section className="py-20 bg-[#0a121a] border-y border-white/5">
        <div className="max-w-5xl mx-auto px-5 lg:px-8">
          <div className="grid gap-4 sm:grid-cols-2">
            {safeRide.benefits.map((b, i) => (
              <div key={i} className="reveal flex items-start gap-3 rounded-xl border border-white/10 bg-[#13212e] p-5">
                <Check className="mt-0.5 shrink-0 text-[var(--gold)]" size={20} />
                <span className="text-gray-200">{b}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* IMMEDIATE SERVICE */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-5">
          <div className="reveal relative overflow-hidden rounded-3xl border border-[var(--gold)]/25 bg-gradient-to-br from-[#13212e] to-[#0a121a] p-10 sm:p-14 text-center">
            <div className="absolute -bottom-16 -left-16 h-56 w-56 rounded-full bg-[var(--gold)]/10 blur-3xl" />
            <h2 className="font-display text-2xl sm:text-3xl font-extrabold text-white">Need Immediate Service?</h2>
            <p className="mt-4 text-muted-foreground max-w-xl mx-auto">
              For quicker responses or if you're in a hurry, call us now to speak directly with our team and confirm your Shadow Path SafeRide service.
            </p>
            <a href={`tel:${contact.phoneRaw}`} className="btn-gold mt-8 inline-flex items-center gap-2 rounded-full px-8 py-4 text-base font-semibold uppercase tracking-widest">
              <Phone size={18} /> Call now: {contact.phone}
            </a>
            <p className="mt-5 text-sm text-muted-foreground">Our team is ready 24/7 to assist you with fast and safe transportation.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SafeRide;
